<!-- first -->
@if (id() === 'erfolg1') {
  <portal-erfolg-1-svg />
}
<!-- second -->
@if (id() === 'erfolg2') {
  <portal-erfolg-2-svg />
}
<!-- third -->
@if (id() === 'erfolg3') {
  <portal-erfolg-3-svg />
}
<!-- fourth -->
@if (id() === 'erfolg4') {
  <portal-erfolg-4-svg />
}
